import { useLanguageStore } from '../store/languageStore';


export const useLanguage = () => {
  const { language, setLanguage } = useLanguageStore();

  return { language, setLanguage };
};